'use strict';

var _regeneratorRuntime = require("/mnt/c/Users/lfege/Code/ipfs-nft-sandbox/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _wrapAsyncGenerator = require("/mnt/c/Users/lfege/Code/ipfs-nft-sandbox/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _awaitAsyncGenerator = require("/mnt/c/Users/lfege/Code/ipfs-nft-sandbox/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _asyncIterator = require("/mnt/c/Users/lfege/Code/ipfs-nft-sandbox/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var _asyncGeneratorDelegate = require("/mnt/c/Users/lfege/Code/ipfs-nft-sandbox/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncGeneratorDelegate");

var CID = require('cids');

var configure = require('../lib/configure');

var toUrlSearchParams = require('../lib/to-url-search-params');

module.exports = configure(function (api) {
  return (
    /*#__PURE__*/
    function () {
      var _gc = _wrapAsyncGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var options,
            res,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
                _context.next = 3;
                return _awaitAsyncGenerator(api.post('repo/gc', {
                  timeout: options.timeout,
                  signal: options.signal,
                  searchParams: toUrlSearchParams(options),
                  headers: options.headers,
                  transform: function transform(res) {
                    return {
                      err: res.Error ? new Error(res.Error) : null,
                      cid: (res.Key || {})['/'] ? new CID(res.Key['/']) : null
                    };
                  }
                }));

              case 3:
                res = _context.sent;
                return _context.delegateYield(_asyncGeneratorDelegate(_asyncIterator(res.ndjson()), _awaitAsyncGenerator), "t0", 5);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function gc() {
        return _gc.apply(this, arguments);
      }

      return gc;
    }()
  );
});